import React from "react"

import { Grid, Button } from "semantic-ui-react"

class ApplicationActions extends React.PureComponent {
  render() {
    const { save, validate } = this.props
    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column floated="left" width={5}>
            <Button fluid onClick={save} primary>
              Προσωρινή αποθήκευση
            </Button>
          </Grid.Column>

          <Grid.Column floated="right" width={5}>
            <Button fluid onClick={validate} positive>
              Οριστική υποβολή
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default ApplicationActions
